import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';

const client = generateClient();

export const createContactOperation = async (
  email,
  givenName,
  familyName,
  consentToProductComms,
) => {
  const response = await client.graphql({
    query: mutations.createContact,
    variables: {
      email,
      givenName,
      familyName,
      consentToProductComms,
    },
    authMode: 'iam',
  });
  return response.data.createContact;
};

// export const emailWelcomeMessageOperation = async (
//   recipient,
//   givenName,
//   familyName,
// ) => {
//   const response = await client.graphql({
//     query: mutations.emailWelcomeMessage, variables: {
//       recipient,
//       givenName,
//       familyName,
//     },
//     authMode: 'iam',
//   });
//   return response.data.emailWelcomeMessage;
// };

export const updateContactAttributeOperation = async (
  email,
  attributeName,
  attributeValue,
) => {
  const response = await client.graphql({
    query: mutations.updateContactAttribute,
    variables: {
      email,
      attributeName,
      attributeValue,
    },
  });
  return response.data.updateContactAttribute;
};

export const emailHealthProWelcomeMessageOperation = async (
  recipient,
  givenName,
  familyName,
) => {
  const response = await client.graphql({
    query: mutations.emailHealthProWelcomeMessage,
    variables: {
      recipient,
      givenName,
      familyName,
    },
    authMode: 'iam',
  });
  return response.data.emailHealthProWelcomeMessage;
};
